import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config.mjs";

const fullTailwindConfig = resolveConfig(tailwindConfig);

export const breakpoints = fullTailwindConfig.theme.screens;

export const numericTailwindBreakpoints = Object.fromEntries(
  Object.entries(breakpoints).map(([key, value]) => [
    key,
    parseInt(value.replace("px", ""), 10),
  ]),
);
